import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const SimpleLabel = ({ name, color, as }) => (
  <span
    className={classnames("simple_label", as)}
    style={{ color }}
  >
    {name}
  </span>
);

SimpleLabel.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  as: PropTypes.oneOf(["item", "box", "dot"]),
};

SimpleLabel.defaultProps = {
  color: "#000000",
};

SimpleLabel.displayName = "SimpleLabel";

export default SimpleLabel;
